import {Injectable} from '@angular/core';
import {additionalSitesStore, Site} from './add-sites.store';
import {map, Observable} from 'rxjs';
import {selectAllEntities} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class AdditionalSitesQuery {
  public siteList$: Observable<Site[]>;
  public siteUrlsList$: Observable<string[]>;
  public isLoading: Observable<boolean>;

  constructor() {
    this.siteUrlsList$ = additionalSitesStore.pipe(
      selectAllEntities(),
      map(list => list.map(site => site.url)),
    );
    this.siteList$ = additionalSitesStore.pipe(selectAllEntities());
    this.isLoading = additionalSitesStore.pipe(select(state => state.isLoading));
  }
}
